<template>
  <div id="admin_promotions_list">
    <CardedTable :items="items" :headers="headers" 
        :height="is_adding_promotion?300:550"
     >
      
      <template v-slot:[`item.expiry`]="{ item }">
        <span class="red--text" v-if="item.expiry == 'expired' && parseInt(item.has_been_ended) == 0"><b>Expired</b></span>
        <span class="red--text" v-if="parseInt(item.has_been_ended) == 1"><b>Ended</b></span>
        <span class="warning--text" v-if="item.expiry == 'pending' && parseInt(item.has_been_ended) == 0"><b>Not Yet</b></span>
        <span class="success--text" v-if="item.expiry == 'live' && parseInt(item.has_been_ended) == 0"><b>Happening</b></span>
      </template>
      <template v-slot:[`item.has_been_ended`]="{ item }">
        <span class="red--text" v-if="parseInt(item.has_been_ended) == 1"><b>Ended</b></span>
        <!-- <span class="blue--text" v-if="parseInt(item.is_verified) == 1"><b>Processing</b></span> -->
        <span class="green--text" v-if="parseInt(item.has_been_ended) == 0"><b>Active</b></span>
      </template>

      
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn @click="on_view_item(item)" x-small rounded text color="success">
          <v-icon>mdi-eye</v-icon>
        </v-btn>
      </template>
    </CardedTable>
  </div>
</template>

<script>
import CardedTable from "../../../components/CardedTable";
import ServerClient from "../../../lib/ServerClient";
import Utils from '../../../lib/Utils';
export default {
  name: "AdminPromotionsList",
  components: {
    CardedTable,
  },
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: () => {
          return ServerClient.Login.get_logged_in_user();
      },
    },
    is_adding_promotion: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
        _user: null,
      items: [],
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: true,
          value: "title",
          filterable: true,
        },
        {
          text: "Business",
          align: "start",
          sortable: false,
          value: "business.name",
          filterable: true,
        },
        {
          text: "Starts",
          align: "center",
          sortable: true,
          value: "starts_on",
          filterable: true,
        },
        {
          text: "Ends",
          align: "center",
          sortable: true,
          value: "ends_on",
          filterable: true,
        },
        {
          text: "Expiry",
          align: "start",
          sortable: true,
          value: "expiry",
          filterable: true,
        },
        {
          text: "Status",
          align: "start",
          sortable: true,
          value: "has_been_ended",
          filterable: true,
        },
        { text: "", value: "actions", sortable: false, align: "end", },
      ],
      indexed_businesses: {}
    };
  },
  methods: {
    auto_fill_select_first_item(){
      //this method is used by the debugger round button
      if(this.items.length > 0){
        this.$emit('on-auto-fill-selected-first-item', this.items[0]);
      }else{
        alert("No promotions available to auto select");
      }
    },
    load_items() {
      this.$emit("on-show-loader");
      ServerClient.Promotions.get_promotions(
        {},
        (res) => {
          this.$emit("on-hide-loader");
          var php_time_now = parseFloat(Utils.date_str_to_php_time(""));
          //console.log("php_time_now:",php_time_now);
          var temp = [];
          for (var index = 0; index < res.length; index++) {
            var promotion = res[index];
            promotion.expiry = php_time_now;
            if(php_time_now < parseFloat(promotion.starts_on_timestamp) ){
                promotion.expiry = "pending";
            }else if(php_time_now >= parseFloat(promotion.starts_on_timestamp) && php_time_now <=  parseFloat(promotion.ends_on_timestamp)){
                promotion.expiry = "live";
            }else if(php_time_now > parseFloat(promotion.ends_on_timestamp) ){
                promotion.expiry = "expired";
            }
            temp.push(promotion);
          }
          this.items = temp;
        },
        (errors) => {
          this.$emit("on-hide-loader");
          console.log("Errors while loading prmomotions on admin promotions list", errors);
        }
      );
    },
    on_view_item(item) {
      if(this.is_adding_promotion == true){
        this.$emit('on-selected-promotion',item);
      }else{
        this.$router.push("/admin/promotions/list/view/" + item.id);
      }
    },
  },
  mounted() {
      this._user = ServerClient.Login.get_logged_in_user();
    this.$emit("set-page-attributes", {
      title: "List Of Created Promotions",
      crumps: [
        {
          text: "Admin",
          disabled: false,
          href: "/admin",
        },
        {
          text: "Promotions",
          disabled: false,
          href: "/admin/promotions",
        },
        {
          text: "List",
          disabled: true,
          href: "/admin/promotions/list",
        },
      ],
    });
    this.load_items();
    if(this.is_adding_promotion == false){
      var options = {
        offset: 50,
        duration: 1000,
        easing: "easeInOutCubic",
      };
      this.$vuetify.goTo("#admin_promotions_list", options);
    }
  },
};
</script>